'use strict'
import { request } from '../../plugins/http'

export default async () => {
    return await request.get('/produto',{params:{ product_module: true}})
}